"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user_group.list': 'Grupy Użytkowników',
    'route.user_group.create': 'Dodaj Grupę Użytkowników',
};
